
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    @Component( {
        name: "Celda",
        props: {},
        components: {
        }
    } )
    export default class Celda extends Vue
    {
        @Prop() Titulo: string;
        @Prop() Posicion: number;
        @Prop() Controlador: ControladorSeccion;

        public get Tipos()
        {
            return this.Controlador.Tipos;
        }

        public get Preset()
        {
            return this.Controlador.Preset;
        }

        public get MensajeError()
        {
            if ( this.Tipo >= 0 && this.Tipos[this.Tipo] && this.Tipos[this.Tipo].MensajeError )
                return this.Tipos[this.Tipo].MensajeError;
            else if ( this && this.Tipos[this.Tipo].Tipo == 'number' )
            {
                return 'Comprueba que las celdas contengan solo valores numericos. Revisa los decimales';
            }
            return '';
        }

        public RecargarPreset()
        {
            if ( this.Preset[this.Posicion] )
            {
                this.Tipo = this.Tipos.findIndex( x => x.Id == this.Preset[this.Posicion] );
                this.Validar();
            } else
            {
                this.Controlador.AgregarAlPreset( this.Posicion, 0 );
                this.Tipo = 0;
            }
        }

        public Registros()
        {
            let a: string[] = [];
            for ( let fila of this.Controlador.Archivo.columnas )
            {
                for ( var i = 0; i < fila.length; i++ )
                {
                    if ( i == this.Posicion )
                    {
                        a.push( fila[i] );
                    }
                }
            }
            return a;
        }

        public async Validar()
        {
            this.Error = false;
            this.Controlador.Columnas[this.Posicion] = 'ok';
            if ( this.Tipos[this.Tipo] )
            {
                for ( let tes of this.Registros() )
                {
                    if ( this.Tipos[this.Tipo].Validar && !await this.Tipos[this.Tipo].Validar( tes ) )
                    {
                        this.Error = true;
                        this.Controlador.Columnas[this.Posicion] = 'error';
                        break;
                    }

                    if ( this.Tipos[this.Tipo].Tipo == 'number' && parseFloat( tes ).isNan() )
                    {
                        this.Error = true;
                        this.Controlador.Columnas[this.Posicion] = 'error';
                        break;
                    }
                }
            }


        }

        public Usado( x: string )
        {
            for ( let i of Object.keys( this.Preset ) )
            {
                if ( this.Preset[parseInt( i )] == x )
                    return true;
            }
        }

        public Abierto: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            //this.RecargarPreset();
            this.Eventos.push( this.Controlador.onRecargarPreset.subscribe( x => this.RecargarPreset() ) );
        }

        public Error: boolean = false;
        public Tipo: number = -1;



        Seleccionar( x: number )
        {
            this.Controlador.AgregarAlPreset( this.Posicion, x );
            this.Tipo = x;
            this.Abierto = false;
            this.Validar();

            //if ( this.Filtros.Valores.Cuenta == x )
            //    return;
            //this.Filtros.Valores.Cuenta = x;
            //this.Filtros.Valores.Tipo = this.Buscador.Filtros.Tipos.findIndex( x => x.Valor.findIndex( a => a.esMercadoLibre ) != -1 );
            //this.Buscador.Buscar( 1 );
        }

    }
